import FloatingChevron from './FloatingChevron.jsx';

export default FloatingChevron;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/FloatingChevron/index.js